//
// Module for the Pay Components Index view
//
rs.module("framework/content/paycomponents/index",

    ["controls/data/grid", "common/visibility", "controls/components/event-banner"],

    function (gridModule, visibility, eventBanner) {
        // variable to prevent most actions on the first page load
        var _execute;

        //
        // Initialize the module
        //
        function initialize(payComponentGridLrsApi, correctionsGridLrsApi, jsSelectors, backendUrls, codeValues, columnIds) {
            var filter = $.js(jsSelectors.filter);
            var currentIndicators = filter.js(jsSelectors.currentIndicators);
            var batchStatus = filter.js(jsSelectors.batchStatus);
            var benefitClaimPaymentKey = filter.js(jsSelectors.benefitClaimPaymentKey);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);
            var payComponentName = $.js(jsSelectors.payComponentName);
            var addPayComponentButton = $.js(jsSelectors.addPayComponentButton);
            var correctionsGrid = $.js(jsSelectors.correctionsGrid);
            var correctionsEditContainer = correctionsGrid.js(jsSelectors.correctionsEditContainer);
            var correctionAmount = correctionsGrid.js(jsSelectors.correctionAmount);
            var deductionCorrectionWarning = correctionsGrid.js(jsSelectors.deductionCorrectionWarning);
            var correctionEffectiveDate = correctionsGrid.js(jsSelectors.correctionEffectiveDate);
            var correctionTerminationDate = correctionsGrid.js(jsSelectors.correctionTerminationDate);
            var cancelButton = correctionsGrid.js(jsSelectors.cancelButton);
            var addCorrectionButton = correctionsGrid.js(jsSelectors.addCorrectionButton);
            var correctionUpdateToken = $.js(jsSelectors.correctionUpdateToken);
            var payComponentCorrection = correctionsGrid.js(jsSelectors.payComponentCorrectionKey);
            var selectedPayComponentKey = correctionsGrid.js(jsSelectors.selectedPayComponentKey);
            var saveButton = correctionsGrid.js(jsSelectors.saveButton);

            // Hook up click event on the radio buttons to reload the grid data via ajax
            currentIndicators.find("input").on('click', UpdatePayComponentGrid);
            batchStatus.change('click', UpdatePayComponentGrid);

            // update the pay components grid
            function UpdatePayComponentGrid() {
                if (_execute) {
                    loadingSpinner.show();

                    gridModule.update(
                        backendUrls.payComponents,
                        {
                            showAll: currentIndicators.find("input:checked").val(),
                            batchStatus: batchStatus.val(),
                            benefitClaimPaymentKey: benefitClaimPaymentKey.val()
                        },
                        payComponentGridLrsApi.agGridApi,
                        function done(gridUpdate) {
                            loadingSpinner.hide();
                            correctionsEditContainer.hide();
                            correctionsGrid.hide();
                            eventBanner.removeErrorMessages();

                            var row = payComponentGridLrsApi.agGridApi.getDisplayedRowAtIndex(0);
                            if (row) {
                                payComponentGridLrsApi.selectedValues = row.data[columnIds.correctionKey];
                            }

                            if (batchStatus.val() == codeValues.trialCode) {
                                visibility.hide(addPayComponentButton);
                                visibility.hide(addCorrectionButton);

                                //disable current/all
                                currentIndicators.find(":input").each(function () {
                                    $(this).prop('disabled', true);
                                });
                            } else {
                                visibility.show(addPayComponentButton);
                                visibility.show(addCorrectionButton);

                                //enable current/all and select current
                                currentIndicators.find(":input").each(function () {
                                    $(this).prop('disabled', false);
                                });

                                // Update the Add button url to include the current selection
                                addPayComponentButton.attr('href', gridUpdate.context.addUrl);
                            }
                        }
                    );
                }
            }

            // On balance detail grid selection change, update detail transactions
            payComponentGridLrsApi.selectionChanged(function (values, rows) {
                if (_execute && values.length > 0) {
                    payComponentSelectionChange(values, rows);
                }
            });

            // Repopulate corrections grid
            function payComponentSelectionChange(values, rows) {
                if (_execute && values.length > 0) {
                    selectedPayComponentKey.val(values[0]);
                    if (rows[0][columnIds.payComponentType][0] == codeValues.deductionCode) {
                        visibility.show(deductionCorrectionWarning);
                    } else {
                        visibility.hide(deductionCorrectionWarning);
                    }
                    eventBanner.removeErrorMessages();
                    loadingSpinner.show();
                    gridModule.update(
                        backendUrls.corrections,
                        {
                            batchStatus: batchStatus.val(),
                            payComponentKey: selectedPayComponentKey.val(),
                            showAllBenefitPayComponents: currentIndicators.find("input:checked").val()
                        },
                        correctionsGridLrsApi.agGridApi,
                        function done() {
                            payComponentName[0].innerHTML = "&nbsp;" + rows[0][columnIds.userDescription];
                            correctionsGrid.show();
                            correctionsEditContainer.hide();
                            loadingSpinner.hide();

                            var row = correctionsGridLrsApi.agGridApi.getDisplayedRowAtIndex(0);
                            if (row) {
                                correctionsGridLrsApi.selectedValues = row.data[columnIds.correctionKey];
                            }
                        }
                    );
                }
            }

            // populate and show the correction edit fields when a row is selected
            correctionsGridLrsApi.selectionChanged(function (values, rows) {
                if (_execute && values.length > 0) {
                    correctionAmount.clearErrors();
                    correctionEffectiveDate.clearErrors();
                    eventBanner.removeErrorMessages();
                    populateCorrectionControls(rows[0][columnIds.correctionKey]);
                }
            });

            // populate the corrections control
            function populateCorrectionControls(payComponentCorrectionKey) {
                //trial corrections aren't editable
                if (batchStatus.val() != codeValues.trialCode) {
                    $.getJSON(backendUrls.correctionData, { payComponentCorrectionKey: payComponentCorrectionKey }).done(function (data) {
                        correctionsEditContainer.show();
                        correctionAmount.val(data.correctionAmount);
                        correctionEffectiveDate.val(data.effectiveDate ? new Date(data.effectiveDate).toISODateString() : null);
                        correctionTerminationDate.val(data.terminationDate ? new Date(data.terminationDate).toISODateString() : null);
                        correctionUpdateToken.val(data.updateToken);
                        payComponentCorrection.val(data.correctionKey);
                    });

                    visibility.show(saveButton);
                }
            }

            // clear the correction edit fields
            function clearCorrectionValues() {
                correctionAmount.clearErrors();
                correctionEffectiveDate.clearErrors();
                correctionsGridLrsApi.selectedValues = null;
                correctionAmount.val(null);
                correctionEffectiveDate.val(null);
                correctionTerminationDate.val(null);
                payComponentCorrection.val(-1);
            }

            // clear and show the editor
            addCorrectionButton.on('click', function () {
                if (_execute) {
                    clearCorrectionValues();
                    correctionsEditContainer.show();
                    correctionAmount.prop("disabled", false);
                    correctionEffectiveDate.prop("disabled", false);
                    correctionTerminationDate.prop("disabled", false);
                    eventBanner.removeErrorMessages();

                    visibility.show(saveButton);
                }
            });

            // clear and hide the editor
            cancelButton.on('click', function () {
                if (_execute) {
                    clearCorrectionValues();
                    correctionsEditContainer.hide();
                    eventBanner.removeErrorMessages();
                }
            });

            _execute = true;
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);